module.exports = __webpack_public_path__ + "img/caret-down.d6e6c521.svg";